import { CommonGet, CommonPost } from '../../helpers/HttpClient';

export default {
  getfactoriesForDropDown,
  getGroupsForDropdown,
  getFactoriesByGroupID,
  getAllFactories,
  getProductsByFactoryID,
  getExecutionDetailsByFactoryAndYear,
  getFinancialYearDetails,
  financialYearEndExecution
};

async function getAllFactories() {
  var factoryArray = [];
  const response = await CommonGet('/api/Factory/GetAllFactories', null);
  for (let item of Object.entries(response.data)) {
    factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
  }
  return factoryArray;
}

async function getFactoriesByGroupID(groupID) {
  var factoryArray = [];
  const response = await CommonGet('/api/Group/GetFactoryByGroupID', "groupID=" + parseInt(groupID));
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] == true) {
      factoryArray[item[1]["factoryID"]] = item[1]["factoryName"];
    }
  }
  return factoryArray;
}

async function getfactoriesForDropDown(groupID) {
  var factoryArray = [];

  const response = await CommonGet('/api/Group/GetFactoryByGroupID', 'groupID=' + groupID)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] == true) {
      factoryArray[item[1]["factoryID"]] = item[1]["factoryName"]
    }
  }
  return factoryArray;
}
async function getGroupsForDropdown() {
  var groupArray = [];
  const response = await CommonGet('/api/Group/GetAllGroups', null)
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"]
    }
  }
  return groupArray;
}

async function getProductsByFactoryID(factoryID) {
  let response = await CommonGet('/api/Product/GetProductsByFactoryID', "factoryID=" + parseInt(factoryID));
  let productArray = []
  for (let item of Object.entries(response.data)) {
    productArray[item[1]["productID"]] = item[1]["productName"]
  }
  return productArray;
}

async function getExecutionDetailsByFactoryAndYear(groupID, factoryID, year) {
  const response = await CommonGet('/api/FinancialYearEndExecution/GetExecutionDetailsByFactoryAndYear', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&year=" + parseInt(year));
  return response;
}

async function getFinancialYearDetails(groupID, factoryID, date) {
  const response = await CommonGet('/api/FinancialYear/FindRelatedFinancialYearByDate', "groupID=" + parseInt(groupID) + "&factoryID=" + parseInt(factoryID) + "&date=" + date);
  return response.data;
}

function financialYearEndExecution(executionModel) {
  const response = CommonPost('/api/FinancialYearEndExecution/FinancialYearEndExecution', null, executionModel);
  return response;
}

